import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={30} height={30} rx={6} fill="#0078D4" />
            <path
                d="M8 8h14v14H8V8z"
                fill="none"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx={15}
                cy={15}
                r={3}
                fill="none"
                stroke="#fff"
                strokeWidth={1.5}
            />
            <path
                d="M12 12l6 6M18 12l-6 6"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
            />
        </svg>
    );
}

export default SvgComponent;
